import { Link } from 'react-router-dom';
import './About.css';

const VALUES = [
  { icon: '🚀', title: 'Speed First', desc: 'Every decision we make optimizes for delivery speed and operational efficiency.' },
  { icon: '🤝', title: 'Partner Mindset', desc: 'We grow when our clients grow. Your success metrics are our success metrics.' },
  { icon: '🔍', title: 'Data Obsessed', desc: 'Every insight is backed by real data, not guesswork. We surface the truth.' },
  { icon: '🔒', title: 'Trust & Security', desc: 'Fleet data, client info, and transactions are protected to the highest standard.' },
];

const TEAM = [
  { name: 'Ahmed Atif', title: 'Co-Founder & CEO', init: 'A' },
  { name: 'Yara Mohamed', title: 'Co-Founder & CTO', init: 'Y' },
  { name: 'Khaled Taha', title: 'Head of Product', init: 'K' },
  { name: 'Mohamed Adel', title: 'Head of Operations', init: 'M' },
];

export default function About() {
  return (
    <main className="about-page">

      {/* HERO */}
      <section className="about-hero">
        <div className="container">
          <p className="section-label">Our Story</p>
          <h1>Built by Operators,<br /><span className="gradient-text">For Operators</span></h1>
          <p>Route Rover was born from a simple frustration: delivery operations were still being managed with spreadsheets, phone calls, and gut instinct. We knew there had to be a smarter way.</p>
        </div>
      </section>

      {/* MISSION */}
      <section className="about-mission">
        <div className="container about-mission__inner">
          <div className="about-mission__text">
            <p className="section-label">Our Mission</p>
            <h2 className="section-title">Give Every Delivery Team Superpowers</h2>
            <p>We believe that a small operations team with the right tools can outperform a large team without them. Route Rover gives you AI, automation, and real-time intelligence — so you can focus on growing your business, not firefighting.</p>
            <p>From the moment an order is placed to the second it's delivered, every step is tracked, optimized, and improved automatically.</p>
            <Link to="/contact" className="cta-primary" style={{ marginTop: 32, display: 'inline-block' }}>Start Your Journey</Link>
          </div>
          <div className="about-mission__stats">
            {[['2025', 'Founded in Cairo'], ['50+', 'Clients Served'], ['1M+', 'Orders Processed'], ['99.9%', 'Platform Uptime']].map(([v, l]) => (
              <div className="about-stat" key={l}>
                <strong>{v}</strong>
                <span>{l}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="about-values">
        <div className="container">
          <p className="section-label">What Drives Us</p>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Our Core Values</h2>
          <div className="values-grid">
            {VALUES.map((v, i) => (
              <div className="value-card" key={i}>
                <div className="value-card__icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="about-team">
        <div className="container">
          <p className="section-label">The People</p>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Meet the Team</h2>
          <div className="team-grid">
            {TEAM.map((m, i) => (
              <div className="team-card" key={i}>
                <div className="team-card__avatar">{m.init}</div>
                <strong>{m.name}</strong>
                <span>{m.title}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-banner">
        <div className="container">
          <h2>Ready to Join Us?</h2>
          <p>Let's build smarter delivery operations together.</p>
          <Link to="/contact" className="cta-primary cta-primary--large">Get in Touch</Link>
        </div>
      </section>

    </main>
  );
}
